import { SkinId } from "../../types";
import { body1TypographyMixin, body2TypographyMixin, body3TypographyMixin, body4TypographyMixin, body5TypographyMixin, tagTypographyMixin, eyebrowTypographyMixin, labelTypographyMixin, textLinkTypographyMixin, display1TypographyMixin, display2TypographyMixin, display3TypographyMixin, display4TypographyMixin, display5TypographyMixin, display6TypographyMixin, display7TypographyMixin, display8TypographyMixin, display9TypographyMixin, ctaTypographyMixin, } from "../mixins/typography";
import { rgProductsBaseTheme } from "../../rg-product-pages/chromas/base";
import { mediaQueries } from "../../shared/mixins/breakpoints";
import { DEFAULT_BREAKPOINTS } from "../../../functional/breakpointUtils";
import tint from "polished/lib/color/tint";
import shade from "polished/lib/color/shade";
const brandColors = {
    primary: "#FFB400",
    secondary: "#6957FF",
    tertiary1: "#FF8F00",
    tertiary2: "#FF6807",
    tertiary3: "#4FA3FF",
    tertiary4: "#00E4FF",
    expansion: "#AE1E44",
    dark1: "#181326",
    light1: "#FFFEF9",
    notDefined: "#FF00FF",
};
const palette1 = {
    accents1: brandColors.tertiary2,
    accents1_hover: tint(0.2, brandColors.tertiary2),
    accents1_disabled: tint(0.8, brandColors.dark1),
    accents2: brandColors.secondary,
    accents2_hover: tint(0.2, brandColors.secondary),
    accents2_disabled: tint(0.8, brandColors.dark1),
    bladetext1: brandColors.dark1,
    bladetext1_light: tint(0.4, brandColors.dark1),
    bladebg1: brandColors.light1,
    bladetext2: brandColors.tertiary2,
    bladebg2: shade(0.2, brandColors.light1),
    bladetext3: brandColors.light1,
    bladebg3: brandColors.secondary,
    bladebg3_hover: tint(0.2, brandColors.secondary),
    bladebg3_disabled: shade(0.2, brandColors.secondary),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: shade(0.2, brandColors.light1),
    ctatext1: brandColors.light1,
    ctatext1_hover: brandColors.light1,
    ctatext1_disabled: tint(0.6, brandColors.dark1),
    ctabg1: brandColors.tertiary2,
    ctabg1_disabled: tint(0.9, brandColors.dark1),
    ctabg1_hover: tint(0.2, brandColors.tertiary2),
    ctatext2: brandColors.light1,
    ctatext2_hover: brandColors.light1,
    ctatext2_disabled: tint(0.6, brandColors.dark1),
    ctabg2: brandColors.secondary,
    ctabg2_hover: tint(0.2, brandColors.secondary),
    ctabg2_disabled: tint(0.9, brandColors.dark1),
    ctastroke1: brandColors.notDefined,
    ctastroke1_hover: brandColors.notDefined,
    ctastroke1_disabled: brandColors.notDefined,
    ctastroke2: brandColors.notDefined,
    ctastroke2_hover: brandColors.notDefined,
    ctastroke2_disabled: brandColors.notDefined,
};
const palette2 = {
    accents1: brandColors.tertiary2,
    accents1_hover: tint(0.2, brandColors.tertiary2),
    accents1_disabled: tint(0.2, brandColors.dark1),
    accents2: brandColors.secondary,
    accents2_hover: tint(0.2, brandColors.secondary),
    accents2_disabled: tint(0.2, brandColors.dark1),
    bladetext1: brandColors.light1,
    bladetext1_light: shade(0.4, brandColors.light1),
    bladebg1: brandColors.dark1,
    bladetext2: brandColors.light1,
    bladebg2: tint(0.2, brandColors.dark1),
    bladetext3: brandColors.dark1,
    bladebg3: brandColors.light1,
    bladebg3_hover: shade(0.2, brandColors.light1),
    bladebg3_disabled: shade(0.2, brandColors.light1),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: tint(0.2, brandColors.dark1),
    ctatext1: brandColors.light1,
    ctatext1_hover: brandColors.light1,
    ctatext1_disabled: tint(0.2, brandColors.dark1),
    ctabg1: brandColors.secondary,
    ctabg1_hover: tint(0.2, brandColors.secondary),
    ctabg1_disabled: tint(0.1, brandColors.dark1),
    ctatext2: brandColors.light1,
    ctatext2_disabled: tint(0.2, brandColors.dark1),
    ctatext2_hover: brandColors.light1,
    ctabg2: brandColors.tertiary2,
    ctabg2_hover: tint(0.2, brandColors.tertiary2),
    ctabg2_disabled: tint(0.1, brandColors.dark1),
    ctastroke1: brandColors.notDefined,
    ctastroke1_hover: brandColors.notDefined,
    ctastroke1_disabled: brandColors.notDefined,
    ctastroke2: brandColors.notDefined,
    ctastroke2_hover: brandColors.notDefined,
    ctastroke2_disabled: brandColors.notDefined,
};
const palette3 = {
    accents1: brandColors.light1,
    accents1_hover: brandColors.tertiary2,
    accents1_disabled: shade(0.2, brandColors.tertiary2),
    accents2: brandColors.secondary,
    accents2_hover: tint(0.2, brandColors.secondary),
    accents2_disabled: shade(0.2, brandColors.tertiary2),
    bladetext1: brandColors.light1,
    bladetext1_light: shade(0.1, brandColors.light1),
    bladebg1: brandColors.tertiary2,
    bladetext2: brandColors.light1,
    bladebg2: shade(0.2, brandColors.tertiary2),
    bladetext3: brandColors.dark1,
    bladebg3: shade(0.6, brandColors.tertiary2),
    bladebg3_hover: shade(0.8, brandColors.tertiary2),
    bladebg3_disabled: shade(0.2, shade(0.6, brandColors.tertiary2)),
    bladetext_ulc: brandColors.light1,
    underlay: brandColors.dark1,
    keyline: shade(0.2, brandColors.tertiary2),
    ctatext1: brandColors.light1,
    ctatext1_hover: brandColors.light1,
    ctatext1_disabled: shade(0.2, brandColors.tertiary2),
    ctabg1: brandColors.expansion,
    ctabg1_hover: tint(0.2, brandColors.expansion),
    ctabg1_disabled: tint(0.2, brandColors.tertiary2),
    ctatext2: brandColors.dark1,
    ctatext2_hover: brandColors.light1,
    ctatext2_disabled: shade(0.2, brandColors.tertiary2),
    ctabg2: brandColors.light1,
    ctabg2_hover: tint(0.2, brandColors.secondary),
    ctabg2_disabled: tint(0.2, brandColors.tertiary2),
    ctastroke1: brandColors.notDefined,
    ctastroke1_hover: brandColors.notDefined,
    ctastroke1_disabled: brandColors.notDefined,
    ctastroke2: brandColors.notDefined,
    ctastroke2_hover: brandColors.notDefined,
    ctastroke2_disabled: brandColors.notDefined,
};
export const TFTChroma = {
    ...rgProductsBaseTheme,
    skinId: SkinId.TFT,
    parentSkinId: SkinId.RiotProduct,
    palettes: {
        palette1,
        palette2,
        palette3,
    },
    palette: {
        primary: "#FF00FF",
        secondary: "#FF00FF",
        tertiary: "#FF00FF",
        quaternary: "#FF00FF",
        background: "#FF00FF",
        foreground: "#FF00FF",
        secondaryBackground: "#FF00FF",
        secondaryForeground: "#FF00FF",
        tertiaryBackground: "#FF00FF",
        tertiaryForeground: "#FF00FF",
        error: "#FF00FF",
        focus: "#FF00FF",
    },
    cssImports: [
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/beaufortforlolja.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/spiegelja.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/beatrice.css",
        "https://lolstatic-a.akamaihd.net/webfonts/live/css/fonts/maleo.css",
    ],
    DEFAULT_BREAKPOINTS,
    mediaQueries,
    typography: {
        ...rgProductsBaseTheme.typography,
        body1: body1TypographyMixin,
        body2: body2TypographyMixin,
        body3: body3TypographyMixin,
        body4: body4TypographyMixin,
        body5: body5TypographyMixin,
        display1: display1TypographyMixin,
        display2: display2TypographyMixin,
        display3: display3TypographyMixin,
        display4: display4TypographyMixin,
        display5: display5TypographyMixin,
        display6: display6TypographyMixin,
        display7: display7TypographyMixin,
        display8: display8TypographyMixin,
        display9: display9TypographyMixin,
        tag: tagTypographyMixin,
        eyebrow: eyebrowTypographyMixin,
        label: labelTypographyMixin,
        textLink: textLinkTypographyMixin,
        cta: ctaTypographyMixin,
    },
};
//# sourceMappingURL=base.js.map